<div class="account-deletion-container">
  <div class="account-deletion-header">
    <div [innerHtml]="'home.account-deletion.are-you-sure' | translate"></div>
  </div>

  <br />
  <slotcom-divider></slotcom-divider>
  <br />

  <div>
    <span [innerHtml]="'home.account-deletion.write-your' | translate"></span>
    <span class="user-name-deletion">{{ userName }}</span>
    <span [innerHtml]="'home.account-deletion.user-input' | translate"></span>
  </div>

  <br />

  <form
    autocomplete="off"
    [formGroup]="accountDeletionForm"
    (ngSubmit)="checkForm()">
    <input
      class="form-control slotcom-input"
      type="text"
      formControlName="userNickname"
      [class.is-invalid]="invalidUserName" />
    @if (invalidUserName) {
      <small
        class="validator-error"
        [innerHtml]="'home.account-deletion.user-input-validator' | translate"></small>
    }
    <br />
    <slotcom-divider></slotcom-divider>
    <br />

    <div class="account-deletion-footer">
      <div class="button-container">
        <slotcom-button
          type="submit"
          class="c-button--purple left-btn"
          audioType="functionality">
          {{ 'home.buttons.accept' | translate | uppercase }}
        </slotcom-button>
        <slotcom-button
          class="c-button--pink right-btn"
          (safeClick)="closeModal()"
          audioType="functionality">
          {{ 'home.buttons.cancel' | translate | uppercase }}
        </slotcom-button>
      </div>
    </div>
  </form>
</div>
